import React from 'react';
import {
  toast as reactToast,
} from 'react-toastify';
import { MAIN_REDUX_STATE_KEY, mainCreators } from "../../actions/mainAction";
import { Notification } from '../../components';
import { storeDispatch } from "../../stores";

export const isShowLoading = (isShowLoading) => {
  storeDispatch(mainCreators.setMainRedux(MAIN_REDUX_STATE_KEY.IS_SHOW_LOADING, isShowLoading));
}

export const isShowAppLoading = (isShowAppLoading) => {
  storeDispatch(mainCreators.setMainRedux(MAIN_REDUX_STATE_KEY.IS_SHOW_APP_LOADING, isShowAppLoading));
}

export const toast = {
  success: (message) => {
    reactToast(
      (({ closeToast }) =>
        <Notification
          ui='success'
          message={message}
        />
      ),
    )
  },
  error: (message) => {
    reactToast(
      (({ closeToast }) =>
        <Notification
          ui='error'
          message={message}
        />
      ),
    )
  },
  info: (message) => {
    reactToast(
      (({ closeToast }) =>
        <Notification
          ui='info'
          message={message}
        />
      ),
    )
  },
}

export const onOpenModal = (params = {}) => {
  params.onClickCancel = params.onClickCancel ? params.onClickCancel : () => { };
  params.onClickConfirm = params.onClickConfirm ? params.onClickConfirm : () => { };
  const onClickCancel = () => {
    params.onClickCancel();
    onCloseModal();
  }
  const modalData = {
    openModalType: params.type,
    message: params.message,
    data: params.data || {},
    title: params.title,
    buttonCancelName: params.buttonCancelName,
    buttonSubmitName: params.buttonSubmitName,
    isDisableOverlayClick: params.isDisableOverlayClick,
    rewardLists: params.rewardLists,
    onClickCancel,
    onClickConfirm: () => {
      params.onClickConfirm();
      onCloseModal();
    }
  }
  storeDispatch(mainCreators.setMainRedux(MAIN_REDUX_STATE_KEY.MODAL_DATA, modalData));
}

export const onCloseModal = () => {
  const modalData = {
    openModalType: undefined
  };
  storeDispatch(mainCreators.setMainRedux(MAIN_REDUX_STATE_KEY.MODAL_DATA, modalData));
}

export const downloadPathUrl = async (pathUrl = '', fileName = '') => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = pathUrl;
  link.click();
}

export const downloadData = (exportObj, exportName, type = 'json') => {
  let data = exportObj;
  if (type === 'json') {
    data = JSON.stringify(exportObj, null, 2);
  }
  const dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(data);
  const downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute('href', dataStr);
  downloadAnchorNode.setAttribute('download', exportName + `.${type}`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}